export enum ContentBlockType {
  Text = 'text',
  Widget = 'widget',
  Callout = 'callout',
  Cases = 'cases',
  Table = 'two_column',
  Toggle = 'toggle',
  SuperLatex = 'superkatex',
}

export interface BaseContentBlock<T extends ContentBlockType> {
  id: string; // stable UUID for comments / diffs / AI
  custom_css?: string; // optional Tailwind-like overrides ("mt-4 text-center")
  type: T;
}
